import _defaults from 'lodash/defaults';

import { Department } from './Department';
import {
    DelegateEmp, Employee, EmpType  
} from './Employee';
import { CurrencyType } from './Money';
import {
    ExpRptUDFConfig, TextUDFConfig, UDFSuppression
} from './UDF';
import { DynamicFilterConfig } from './DynamicFilterConfig';
import { UIFlags } from './UIFlags';

interface AccountConfigCompany {
    EnableEmburseAnalytics: boolean;
    EnableMultiTaxAuth: boolean;
    EnableInvoicePurchaseOrders: boolean;
    EnableArchiveData: boolean;
    IsCertifyNow: boolean;
    EnableKronosUserSync: boolean;
    EnableManageUsers: boolean;
    EnableAdditionalApproval: boolean;
    EnableAmazonBusiness: boolean;
    EnableNexusNetsuiteAdminView: boolean;
    HasCompanyPGPKeys: boolean;
    EnableBulkUploadTools: boolean;
    EnableSFTPConfig: boolean;
    EnableDirectDepositImport: boolean;
    HasPaymentProfile: boolean;
    APSyncPartner: string;
}

interface AccountConfigUser {
    Permissions: string[];
}

// Default AccountConfig values to fill-in with
const defaultAccountConfig: Partial<AccountConfig> = {
    Emp_Department: new Department(),
    Emp_CurrencyType: new CurrencyType(),
    Emp_Type: EmpType.None,
    Emp_Locale: 'en-US',
    Dept_UseSearch: false,
    Dept_Suppress: false,
    Dept_UseExpCatFilters: false,
    Dept_DynamicFiltering: {},
    DynamicFilterConfig: [],
    Company_UseUDF: true,
    Company_UseDynamicFiltering: true,
    Company_UseElementSuppression: true,
    Company_HasActiveCreditCardProgram: false,
    ExpCat_DynamicFiltering: {},
    ExpCat_UDFSuppression: {},
    ExpCat_TextUDFSuppression: {}
};

class AccountConfig {
    public Emp: Employee;
    public OriginalEmp: Employee;

    public Emp_Department: Department;
    public Emp_CurrencyType: CurrencyType;
    public Emp_Type: EmpType;
    public Emp_Locale: string;

    public Dept_UseSearch: boolean;
    public Dept_Suppress: boolean;
    public Dept_UseExpCatFilters: boolean;
    public Dept_DynamicFiltering: {[k: number]: boolean};

    public DynamicFilterConfig: DynamicFilterConfig[];

    public Company_UseUDF: boolean;
    public Company_UseDynamicFiltering: boolean;
    public Company_UseElementSuppression: boolean;
    public Company_UseMultipleCurrencies: boolean;
    public Company_LanguageUpdateTime?: string;
    public Company_HasActiveCreditCardProgram: boolean;
    public Company_LogoURL?: string;
    public Company_CompanyStatusName?: string;
    public Company_EnableAssuranceAIRules: boolean;
    public Company_ShowLegacyInstantAuditRules: boolean;

    public ExpCat_DynamicFiltering: {[k: number]: boolean};
    public ExpCat_UDFSuppression: {[k: number]: UDFSuppression};
    public ExpCat_TextUDFSuppression: {[k: number]: UDFSuppression};

    public ExpRptUDFConfig: {[k: number]: ExpRptUDFConfig};
    public TextUDFConfig: {[k: number]: TextUDFConfig};
    public AllowedFileTypes: string[];
    public TravelAgentURL: string;
    public LanguageCode: string;

    public IsAdmin: boolean;

    public IsCertifyMobile: boolean;

    public NexoniaMigratedCustomer: boolean;
    // Need to ask how this is interpreted
    public UIFlags: UIFlags;

    public Company: AccountConfigCompany;

    public User: AccountConfigUser;

    public EmpDelegateList: DelegateEmp[];

    public constructor (accountConfig: Partial<AccountConfig>) {
        // Assign the passed account config parameters
        // Any properties left `undefined`, replace with defaults
        _defaults(this, accountConfig, defaultAccountConfig);
    }
}

export { AccountConfig, AccountConfigCompany, AccountConfigUser };
